import React, {ReactNode, ReactNodeArray, CSSProperties} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import DebtAndUpdatePaymentBlockData from '../../../Models/Content/DebtAndUpdatePaymentBlockData';
import DebtPayment from './DebtPayment';

export default class DebtAndUpdatePaymentBlock extends EpiComponent<DebtAndUpdatePaymentBlockData> {
  public render(): null | ReactNode | ReactNodeArray {
    return <DebtPayment context={this.getContext()} contentData={this.props.data} />;
  }
}
